// extracted by mini-css-extract-plugin
export default {"cards":"bestProducts_cards__rC+Fw","showMore":"bestProducts_showMore__nuvt2"};